import type { ThemePreset } from '../../models';
import { getThemePreset } from '../themePresets';

export function buildBaseStyles(themePreset?: ThemePreset): string {
    const preset = getThemePreset(themePreset);
    return `
        /* CSS Base Reset & Typography */
        * { box-sizing: border-box; margin: 0; padding: 0; }
        :root {
            --theme-font: ${preset.fontFamily};
            --theme-bg: ${preset.bg};
            --theme-surface: ${preset.surface};
            --theme-text: ${preset.text};
            --theme-muted: ${preset.muted};
            --theme-border: ${preset.border};
            --theme-radius: ${preset.radius};
            --theme-radius-lg: ${preset.radiusLg};
            --theme-section-pad-y: ${preset.sectionPadY};
            --theme-section-pad-x: ${preset.sectionPadX};
            --theme-section-pad-y-tight: ${preset.sectionPadYTight};
            --theme-hero-pad-y: ${preset.heroPadY};
            --theme-input-bg: ${preset.inputBg};
            --theme-accent: ${preset.accent};
            --theme-accent-alt: ${preset.accentAlt};
            --theme-accent-text: ${preset.accentText};
            --theme-accent-alt-text: ${preset.accentAltText};
            --theme-shadow: ${preset.shadow};
        }
        body {
            font-family: var(--theme-font);
            -webkit-font-smoothing: antialiased;
            background-color: var(--theme-bg);
            color: var(--theme-text);
        }
        input, textarea, select, button { font-family: inherit; }
        input:focus, textarea:focus { outline: 2px solid var(--theme-accent); outline-offset: -1px; }
        button:disabled { opacity: 0.5; cursor: not-allowed !important; }
    `;
}
